import React from 'react';
import heroImage from './../../assets/images/3a.jpg';
import styles from './Section0.module.css';

const openInquiryForm = () => {
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#form`);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
};

const Section0: React.FC = () => (
  <section id="section0" className={styles.hero} style={{ backgroundImage: `url(${heroImage})` }}>
    <div className={styles.backdrop} />
    <div className={styles.content}>
      <div className={styles.copy}>
        <p className={styles.eyebrow}>Геодезически услуги в цяла България</p>
        <div className={styles.logo} aria-label="Geoworld"><span>GEO</span><strong>WORLD</strong></div>
        <h1>Нуждаете се от геодезист? Ние идваме при Вас.</h1>
        <p className={styles.lead}>Заснемане, трасиране и кадастрални услуги за Вашия имот или проект — навсякъде в България. Получете бърз отговор и ясна, конкурентна оферта.</p>
        <div className={styles.actions}>
          <button type="button" className={styles.primaryButton} onClick={openInquiryForm}>Получете безплатна консултация <span>→</span></button>
          <a className={styles.textLink} href="tel:+359883354449">+359 883 354 449</a>
          <a className={styles.textLink} href="tel:+359899271495">+359 899 271 495</a>
        </div>
        <p className={styles.reassurance}>✓ Без ангажимент &nbsp;&nbsp; ✓ Отговор до 24 часа &nbsp;&nbsp; ✓ Обслужване в цяла България</p>
      </div>
      <div className={styles.floatingCard}>
        <span className={styles.cardNumber}>Конкурентна оферта</span>
        <p>Изпратете кратка заявка и ще получите ясна оферта и най-подходящите следващи стъпки за Вашия обект.</p>
      </div>
    </div>
    <div className={styles.stats}>
      <div><strong>10+</strong><span>години професионален опит</span></div>
      <div><strong>24 ч.</strong><span>бърз отговор на запитване</span></div>
      <div><strong>BG</strong><span>геодезически услуги в цяла България</span></div>
    </div>
  </section>
);

export default Section0;
